<script>
import Multiselect from "vue-multiselect";
import widget from "./widget.vue";
import composicao from "./composicao.vue";
export default {
  props: {
    empresa: { type: Object, required: true },
    ibge: { type: Array },
    listProdutos: { type: Array },
    listLocaisEstoque: { type: Array },
  },
  components: { Multiselect, widget, composicao },
  data() {
    return {
      compoe_produtos_vet:[],
      locaisEstoque: [],
      titleBody: "Produto Confecção",
      list_produtos: [],
      product_confec: {
        number_order: 2,
        filial_id: 1,
        cod: 2,
        reference: "ola",
        name: "produto",
        in_stock: "2",
        amount: "45",
        forecast: "2023-06-30T08:43", // previsão
        processed: 1,
        stock_destiny: 1,
        value: 50.0,
        date_destiny: "2023-06-30T08:43",
        alter_last: "alterado",
        user_cod: 2,
      },
      name: null,
      objeto_widget: null,
      select_produto: null,
      confecao: {
        id: null,
        codigo: null,
        referencia: null,
        produto_id: null,
        produto: null,
        quantidade: null,
        dt_conclusao: null,
        processado_id: null,
        processado: false,
        local_estoque_id: null,
        dt_cadastro: null,
        ultima_alt: null,
        descricao: null,
        cod_user: null,
        empresa_id: null,
        created_at: null,
        updated_at: null,
      },
      modal_abr: false,
      composicoes: [],
      exibir_composicao: false,
      estoque_produto: null,
      consumo: null,
      estoques_vetor: [],
      listEstoques: [],
    };
  },
  created() {
  },
  mounted() {
    this.$emit("newTitle", this.titleBody);
    this.locaisEstoque = this.listLocaisEstoque;
    this.list_produtos = this.listProdutos;
  },

  methods: {
    calcular_consumo(event) {
      let quantidade = event.target.value;
      this.consumo = quantidade * this.estoque_produto;
    },
    seleciona_processado(event) {
      this.confecao.processado = event.target.value;
      console.log(this.confecao.processado);
    },
    remove_produto(event) {
      console.log('remover', event);
      this.select_produto = null;
      this.estoque_produto = null;
    },
    seleciona_produto(produto) {
      this.confecao.produto = produto;
      this.confecao.codigo = produto.processado_id;
      this.confecao.referencia = produto.codbarras;
      // esse vetor vai ser usado para fazer um novo fitros , quando for selecionado o local de estoque
      this.estoques_vetor = produto.estoque;
      // se o estoque for maior que 0, então eu vou pegar o último item do array
      if (produto.estoque && produto.estoque.length > 0) {
        let array_estoque_pruduto = produto.estoque;
        let tam_array_estoque_prod = array_estoque_pruduto.length;
        //  tenho que filttrar esse estoque , com a locaL_estoque_id tb,
        this.estoque_produto =
          array_estoque_pruduto[tam_array_estoque_prod - 1].qtdenew;
      }

      this.confecao.produto_id = produto.id;
      this.confecao.descricao = produto.produto_nome;
      this.compoe_produtos_vet = produto.compoe_produtos;

      if (produto.compoe_produtos != null) {
        this.exibir_composicao = true;
        this.composicoes = produto.compoe_produtos;
      } else {
        this.exibir_composicao = false;
      }
    },
    selecionando_name(objeto) {
      this.product_confec.name = objeto.produto_nome;
      console.log('name', this.product_confec.name);
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    setPost() {
        this.confecao.processado_id = this.confecao.processado == 1 ? 1 : 0;

        if (this.confecao.produto.produto_materiaprima != -1) {
          console.log('objeto do insert', this.confecao);
          this.$emit("doPost", this.confecao);
        } else {
          this.makeToast('info', 'Este produto não pode ser produzido pois é uma materia prima');
        }
    },
    opcaoSelecionada(event) {
      let id_select = event.target.value;
      this.confecao.local_estoque_id = id_select;
      let objeto_selecionado = this.locaisEstoque.find((p) => p.id == id_select);
      this.objeto_widget = objeto_selecionado;

      if (id_select == -1) {
        this.objeto_widget = null;
      }

      let local_estoque_id = id_select; // usado no if

      if (this.estoques_vetor && this.estoques_vetor.length > 0) {
        let vetor = this.estoques_vetor;
        let vazio = [];
        vetor.forEach((item, index) => {
          let item_local_id = item.local_estoque_id;

          if (item_local_id == local_estoque_id) {
            this.listEstoques = vazio;
            this.listEstoques[index] = item;
          }
        });
      }

      let new_tam = this.listEstoques.length;
      let new_qtd_valor = this.estoques_vetor[new_tam - 1];
      console.log("valor objeto");
      console.log(new_qtd_valor.qtdenew);

      this.estoque_produto = new_qtd_valor.qtdenew;
      console.log("valor Array");
      console.log(this.listEstoques);
    },
    modal_composicao() {
      this.modal_abr = true;
    },
    back() {
      this.modal_abr = false;
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <widget
            :objeto="objeto_widget"
            :estoque_produto="estoque_produto"
            :consumo="consumo"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div :class="exibir_composicao == true ? 'col-md-3' : 'col-md-4'">
          <Label>
            <b-badge
              data-name="credito"
              class="field-status"
              :variant="confecao.produto_id == null ? 'danger' : 'success'"
              >{{ "* Código" }}</b-badge
            ></Label
          >
          <input
            v-model="confecao.produto_id"
            type="number"
            class="form-control text-left"
            placeholder="Digite o valor"
          />
        </div>
        <div :class="exibir_composicao == true ? 'col-md-3' : 'col-md-4'">
          <Label
            ><b-badge
              data-name="produto-referencia"
              class="field-status"
              :variant="confecao.referencia == null ? 'danger' : 'success'"
              >{{ "* Referência" }}</b-badge
            ></Label
          >

          <input
            v-model="confecao.referencia"
            type="number"
            class="form-control text-left"
            placeholder="Digite o valor"
          />
        </div>
        <div :class="exibir_composicao == true ? 'col-md-4' : 'col-md-4'">
          <label>
            <b-badge
              data-name="credito"
              class="field-status"
              :variant="select_produto == null ? 'danger' : 'success'"
            >
              * Nome do Produto
            </b-badge>
          </label>
          <multiselect
            @select="seleciona_produto($event)"
            @remove="remove_produto($event)"
            v-model="select_produto"
            :options="list_produtos"
            label="produto_nome"
            track-by="id"
          >
          </multiselect>
        </div>
        <div class="col-md-2 mt-1" v-if="exibir_composicao">
          <button
            class="btn btn-secondary mt-4"
            @click.prevent="modal_composicao()"
          >
            Composição
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="modal_abr">
          <composicao
            :abrir_modal="modal_abr"
            @back="back"
            :composicoes="composicoes"
          >
          </composicao>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-3">
          <Label
            ><b-badge
              data-name="credito"
              class="field-status"
              :variant="confecao.quantidade == null ? 'danger' : 'success'"
              >{{ "* Quantidade" }}</b-badge
            ></Label
          >

          <input
            v-model="confecao.quantidade"
            type="number"
            class="form-control text-left"
            placeholder="Digite o valor"
            min="1"
            @input="calcular_consumo($event)"
          />
        </div>
        <div class="col-md-3">
          <Label
            ><b-badge
              data-name="credito"
              class="field-status"
              :variant="confecao.dt_conclusao == null ? 'danger' : 'success'"
              >{{ "* Previsão de Conclusão" }}</b-badge
            ></Label
          >

          <input
            v-model="confecao.dt_conclusao"
            type="date"
            class="form-control text-left"
            placeholder="Digite o valor"
          />
        </div>
        <div class="col-md-3">
          <label>Situação</label>
          <b-form-checkbox v-model="confecao.processado" switch class="mb-1">
            <label>Processado?</label>
          </b-form-checkbox>
        </div>
        <div class="col-md-3">
          <Label
            ><b-badge
              data-name="credito"
              class="field-status"
              :variant="
                confecao.local_estoque_id == null ? 'danger' : 'success'
              "
              >{{ "* Local de Estoque" }}</b-badge
            ></Label
          >

          <select
            class="form-control"
            id="selectLocalEstoque"
            @change="opcaoSelecionada($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in locaisEstoque"
              :key="index"
              :value="item.id"
            >
              {{ item.descricao }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-secondary" @click.prevent="setPost()">
            Inserir
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>